import { Button } from "primereact/button";
import React from "react";
import { FilterButtonSVG } from "../../../../assets/SVGs/FilterButtonSVG";

const FilterButton = (props: any) => {
  return (
    <>
      <Button
        className="tw-flex focus:tw-shadow-none tw-px-3 tw-py-2 tw-rounded tw-font-medium tw-gap-2"
        severity="secondary"
        onClick={(event) => props.menu.current?.toggle(event)}
      >
        <FilterButtonSVG />
        <span className="tw-text-base">Filters</span>
      </Button>
    </>
  );
};

export default FilterButton;
